import React from 'react'

interface Props {
  title?: string
}

interface State { }

export class Card extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
  }

  public render() {
    return (
      <div className="card mb-4">
        {this.props.title && <h3 className="card-header">{this.props.title}</h3>}
        <div className="card-body">
          {this.props.children}
        </div>
      </div>
    )
  }
}